import { Button, Flex, Input, message, Modal, Typography } from 'antd';
import { useState } from 'react';

import { authService } from '../services/auth-service';
import { Logo } from './logo';

const { Text, Title } = Typography;

type AuthModalPropsType = {
    visible: boolean;
    contact: string | null;
    contactType: 'email' | 'phone';
    uuid: string;
    onSuccess: () => void;
    onCancel: () => void;
};

export const AuthModal = ({ visible, contact, contactType, uuid, onSuccess, onCancel }: AuthModalPropsType) => {
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);

    const handleSubmit = async () => {
        if (otp.length !== 6) {
            message.error('Please enter 6-digit code');
            return;
        }

        setLoading(true);
        try {
            await authService.loginComplete(otp);
            message.success('Login successful');
            onSuccess();
        } catch (error) {
            message.error('Invalid code. Please try again');
            console.error('Login error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleResendCode = async () => {
        setResendLoading(true);
        try {
            await authService.loginStart(uuid);
            message.success('Code has been resent');
            setOtp('');
        } catch (error) {
            message.error('Failed to resend code. Please try again');
            console.error('Resend code error:', error);
        } finally {
            setResendLoading(false);
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 6);
        setOtp(value);
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && otp.length === 6) {
            handleSubmit();
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            centered
            width={400}
            closable={true}
            style={{ marginTop: '-10%' }}
        >
            <Flex vertical gap={24} style={{ padding: '20px 0' }}>
                <Flex vertical justify="center" align="center" gap={20}>
                    <Flex align={'center'} gap={20}>
                        <Logo type="short" size={'40px'} />
                        <span style={{ fontSize: 20, fontWeight: 'bold' }}>SITEMAX - Contractor</span>
                        {/*<Logo type="full" />*/}
                    </Flex>

                    <Flex align="center" gap={12}>
                        <Title level={3} style={{ margin: 0 }}>
                            Sign In
                        </Title>
                    </Flex>
                </Flex>

                <Flex vertical gap={8}>
                    <Text>Access code has been sent to your {contactType === 'email' ? 'email' : 'phone'}:</Text>
                    <Input size={'large'} value={contact as string} disabled style={{ fontSize: 18 }} />
                </Flex>

                <Flex vertical gap={12}>
                    <Text>Enter 6-digit code:</Text>
                    <Input
                        size="large"
                        value={otp}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        placeholder="000000"
                        maxLength={6}
                        style={{
                            fontSize: 24,
                            textAlign: 'center',
                            letterSpacing: 8,
                        }}
                        autoFocus
                    />
                </Flex>

                <Button
                    type="primary"
                    size="large"
                    onClick={handleSubmit}
                    loading={loading}
                    disabled={otp.length !== 6}
                    block
                >
                    Sign In
                </Button>

                <Flex justify="center" align="center">
                    <Button type="link" onClick={handleResendCode} loading={resendLoading} disabled={loading}>
                        Resend Code
                    </Button>
                </Flex>
            </Flex>
        </Modal>
    );
};
